import axios from 'axios'
import store from './store'
import properties from "./properties";
import Utils from "./utilities";

// ToDo Get Actual URL
// export const BASE_URL = 'https://service.eudoxus.gr/';
// export const BASE_URL = 'https://test.eudoxus.gr/';
//export const BASE_URL = '';
export const BASE_URL = process.env.VUE_APP_API_ENDPOINT;

let requests = {
    login(loadingModal , loadingPage, loginCallbackSuccessProfile, loginCallbackSuccessBooks){
        axios.get(BASE_URL + 'student/api/student')
            .then((response) => {
                loginCallbackSuccessProfile(response)
            }).catch(error =>{
                store.commit('setLoadingModal', false);
                store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
                store.commit('setErrorMessageModal',true);
        });

        axios.get(BASE_URL + 'student/api/sb/studentbooks')
            .then((response) =>{
                loginCallbackSuccessBooks(response);
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
    
    get(path, getCallBack) {
        
        axios.get(BASE_URL + path,
            {headers: {
                    'Content-Type': 'application/json',
                }})
            .then((response =>{
                getCallBack(response.data)
            }))
            .catch(error =>{
                store.commit('setLoadingModal', false);
                store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
                store.commit('setErrorMessageModal',true);
            });
    },
    
    post(path, data,  postCallBack) {
        
        axios.post(BASE_URL + path,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then((response =>{
                postCallBack(response.data)
            }))
            .catch(error =>{
                store.commit('setLoadingModal', false);
                store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
                store.commit('setErrorMessageModal',true);
            });
    },
    
    put(path, data ,  putCallBack) {
        
        axios.put(BASE_URL + path, data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        )
            .then((response =>{
                putCallBack(response.data)
            }))
            .catch(error =>{
                store.commit('setLoadingModal', false);
                store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
                store.commit('setErrorMessageModal',true);
            });
    },
    
    putForFilesWithRetryIfNotSuccess(path, data,unsuccessfulCallBack) {
        
        axios.put(BASE_URL + path,
            data,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then((response =>{
                store.commit('setLoadingModal', false);
                Utils.downLoadPDFNewTab(response);
            }))
            .catch((error => {
                const binaryString = atob(error.response.headers.errormessage);
                
                // Convert binary string to UTF-8 text
                const decodedErrorMessage = decodeURIComponent(escape(binaryString));
                unsuccessfulCallBack(decodedErrorMessage)
                
            }))
    },
    
    
    active(loginCallBackSuccessActive){
        //    https://test.eudoxus.gr/student/api/statement/active
        axios.get(BASE_URL + 'student/api/statement/active')
            .then((response) =>{
                loginCallBackSuccessActive(response.data)
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
    statement(loginCallBackSuccessStatement){
        //https://test.eudoxus.gr/student/api/statement
        axios.get(BASE_URL + 'student/api/statement')
            .then((response) =>{
                loginCallBackSuccessStatement(response)
            });
    },
    saveCredentials(requestCredentials, saveCredentialsSuccess){
        axios.post(BASE_URL + 'student/api/student' ,  requestCredentials ).then((response) =>{
            saveCredentialsSuccess(response.data)
        }).catch(error =>{
            store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
    selectedDepartment(successSelectedDepartment){
        //    http://127.0.0.1:9080/student/api/secretariat/freeschools/selected
        axios.get(BASE_URL + 'student/api/secretariat/freeschools/selected' ,{ cache: false })
            .then((response) =>{
                successSelectedDepartment(response.data);
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
    allCourses(id , createCoursesArrayId, errorAllCourses){
        //    http://127.0.0.1:9080/student/api/course/active?secretariatId=****
        axios.get(BASE_URL + 'student/api/course/active?secretariatId='+ id , { cache: false })
            .then((response) =>{
                createCoursesArrayId(response);
            }).catch(error =>{
            errorAllCourses();
            store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
    allBooksGroupByCourse(id , createListOfBooksById, errorAllBooksGroupByCourse){
        //    http://127.0.0.1:9080/student/api/bookgroup/secretariatId/****
        axios.get(BASE_URL + 'student/api/bookgroup/secretariatId/'+ id, { cache: false })
            .then((response) =>{
                if(response.data != null){
                    createListOfBooksById(response.data)
                }
            }).catch(error =>{
            errorAllBooksGroupByCourse();
            store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
    freebookCourses(id , createListOfEbooksById){
        axios.post(BASE_URL + 'student/api/freebook/courses' , id, { cache: false })
            .then((response) =>{
                if(response.data != null){
                    createListOfEbooksById(response.data)
                }
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setLoadingModal', false);
            // store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
    //https://test.eudoxus.gr/student/api/statement/points?id=*****&id=*****&id=****
    points(urlParamsPoints , passPointsToStore){
        axios.get(BASE_URL + 'student/api/statement/points?'+urlParamsPoints)
            .then((response) =>{
                if (response.data !=null){
                    passPointsToStore(response.data);
                }
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
//    https://test.eudoxus.gr/student/api/exchange/studentbook/match?bookgroupId=*****&bookgroupId=******&bookgroupId=******
    match(urlParamsMatch, passMatchToStore){
        axios.get(BASE_URL + 'student/api/exchange/studentbook/match?'+urlParamsMatch)
            .then((response) =>{
                if (response.data !=null){
                    passMatchToStore(response.data);
                }
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
    courier(urlEncode, loginCallBackSuccessCourier) {
        //            requests.courier(BASE_URL + Utils.urlEncode(myInput))
        axios.get(BASE_URL + 'student/api/courrier/id/'+urlEncode)
            .then((response) =>{
                if (response.data !=null){
                    loginCallBackSuccessCourier(response.data);
                }
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
        //requests.courier(BASE_URL + Utils.urlEncode(myInput))
    },
//    https://test.eudoxus.gr/student/api/courrier/zipcode/14123
    zipCode(urlParamsZipCode, callBackSuccessZipCode , onRequestErrors){
        axios.get(BASE_URL + 'student/api/courrier/zipcode/' + urlParamsZipCode)
            .then((response) =>{
                if (response.data !=null){
                    callBackSuccessZipCode(response.data);
                }
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            onRequestErrors(error)
            // store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            // store.commit('setErrorMessageModal',true);
        });
    },
    //https://test.eudoxus.gr/student/api/statement
    finalDeclaration(statementBookGroup, CallBackSuccessFinalDeclaration){
        axios.post(BASE_URL + 'student/api/statement', statementBookGroup)
            .then((response) =>{
                CallBackSuccessFinalDeclaration(response.data);
            }).catch(error =>{
            store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
//    https://test.eudoxus.gr/student/api/exchange/studentbook?studentBookId=67170617
    exchangeStudentData(studentBookId, callBuckSuccessExchangeStudentData){
        axios.get(BASE_URL + 'student/api/exchange/studentbook?studentBookId=' + studentBookId)
            .then((response) =>{
                callBuckSuccessExchangeStudentData(response.data);
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
//    https://test.eudoxus.gr/student/api/exchange/source/select =>dstStatementBookId -> POST
//    /student/api/exchange/source/select
    select(dstStatementBookId, callBuckSuccessdstStatementBookId){
        axios.post(BASE_URL + 'student/api/exchange/source/select', dstStatementBookId)
            .then((response) =>{
                callBuckSuccessdstStatementBookId(response.data);
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
//    https://test.eudoxus.gr/student/api/exchange/pin?id=83123970 ==> GET
    getPin(dstStatementBookId, callBuckSuccessGetPin){
        axios.get(BASE_URL + 'student/api/exchange/pin?id=' + dstStatementBookId)
            .then((response) =>{
                callBuckSuccessGetPin(response.data);
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
//    https://test.eudoxus.gr/student/api/sb/studentbooks
    listOfExchangeBooks(callBackSuccessExchangeBooks, onRequestErrors){
        axios.get(BASE_URL + 'student/api/sb/studentbooks')
            .then((response) =>{
                callBackSuccessExchangeBooks(response.data);
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },
//    https://test.eudoxus.gr/student/api/exchange/exchangable
    postExchangeBook(exchangeObject, successPostExchangeBook){
        axios.post(BASE_URL + 'student/api/exchange/exchangable',exchangeObject)
            .then((response) =>{
                successPostExchangeBook(response);
            }).catch(error =>{
                store.commit('setLoadingModal', false);
            store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
            store.commit('setErrorMessageModal',true);
        });
    },

    // http://127.0.0.1:9080/student/api/exchange/deliver
    exchangeCodeDeliver(exchangeCodeDeliverObject, successExchangeCodeDeliver, errorExchangeCodeDeliver){
        axios.post(BASE_URL + 'student/api/exchange/deliver', exchangeCodeDeliverObject)
            .then((response) =>{
                successExchangeCodeDeliver(response);
            })
            .catch(error =>{
                errorExchangeCodeDeliver();
                store.commit('setLoadingModal', false);
                store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
                store.commit('setErrorMessageModal',true);
            })
    },

    //http://127.0.0.1:8080/student/api/books/search?query=id:123&count=5
    searchBooksToExchange(query, successSearchBooksToExchange) {
        axios.get(BASE_URL + 'student/api/books/search?query=' + query + '&count=5')
            .then((response) =>{
                successSearchBooksToExchange(response.data)
            })
            .catch(error =>{
                store.commit('setLoadingModal', false);
                store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
                store.commit('setErrorMessageModal',true);
            })
    },

//    http://127.0.0.1:9080/student/api/sb/add
    addBookToExchange(bookid, successAddBookToExchange) {
        axios.post(BASE_URL + 'student/api/sb/add', bookid)
            .then((response) =>{
                successAddBookToExchange(response.data)
            })
            .catch(error =>{
                store.commit('setLoadingModal', false);
                store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
                store.commit('setErrorMessageModal',true);
            })
    },

//    http://127.0.0.1:9080/student/api/statement/resendpin?id=
    getPIN(statementId, successGetPIN){
        axios.get(BASE_URL + 'student/api/statement/resendpin?id=' + statementId)
            .then((response) =>{
                successGetPIN(response.data)
            })
    },
    getLibrary(studendId, successGetLibrary) {
        axios.get(BASE_URL + 'student/api/institution/libraries/student/' + studendId)
            .then((response) =>{
                successGetLibrary(response.data)
            })
            .catch(error =>{

            })
    },
    //http://127.0.0.1:9080/student/api/sb/remove
    removeBook(studentBookId, book, successRemoveBook){
        axios.post(BASE_URL + 'student/api/sb/remove', studentBookId)
            .then((response) =>{
                successRemoveBook(book)
            })
            .catch(error => {
                console.log(error);
                store.commit('setLoadingModal', false);
                store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
                store.commit('setErrorMessageModal',true);
            })
    },

//    http://127.0.0.1:9080/student/api/pgs/checkCourceRegistrationBatch
    checkCourceRegistration(coursesCodes, successCheckCourceRegistration) {
        axios.post(BASE_URL + 'student/api/pgs/checkCourceRegistrationBatch', coursesCodes)
            .then((response) =>{
                successCheckCourceRegistration(response.data)
            })
            .catch((error) =>{
                store.commit('setLoadingModal', false);
                store.commit('setErrorMessageObject',{message : properties.getErrorMessage(error.response.data.error)});
                store.commit('setErrorMessageModal',true);
            })
    }
};

export default requests
